export default "__VITE_ASSET__CMMcXkhl__"